import clsx from 'clsx';
import { sanitizeContentfulBlockId } from 'utils/contentful';
import styles from './ColumnBlock.module.scss';
import RichText from './RichText';
import type { InspectorPropsType } from 'hooks/useLivePreview';
import type { IColumnBlock3Fields } from 'types/contentful/generated';

type Props = IColumnBlock3Fields & {
  inspectorProps?: InspectorPropsType;
};

const ColumnBlock = ({
  blockId,
  titleColumn1,
  textColumn1,
  titleColumn2,
  textColumn2,
  titleColumn3,
  textColumn3,
  inspectorProps,
}: Props): JSX.Element => (
  <div
    id={sanitizeContentfulBlockId(blockId)}
    className={clsx(styles.container, textColumn3 && styles.threeColumns)}
  >
    {!!textColumn1 && (
      <div {...inspectorProps?.({ fieldId: 'titleColumn1' })}>
        {titleColumn1 && (
          <h3
            className={styles.headline}
            {...inspectorProps?.({ fieldId: 'titleColumn1' })}
          >
            {titleColumn1}
          </h3>
        )}
        <RichText
          fields={textColumn1}
          inspectorProps={{ ...inspectorProps?.({ fieldId: 'textColumn1' }) }}
        />
      </div>
    )}
    {!!textColumn2 && (
      <div>
        {titleColumn2 && (
          <h3
            className={styles.headline}
            {...inspectorProps?.({ fieldId: 'titleColumn2' })}
          >
            {titleColumn2}
          </h3>
        )}
        <RichText
          fields={textColumn2}
          inspectorProps={{ ...inspectorProps?.({ fieldId: 'textColumn2' }) }}
        />
      </div>
    )}
    {!!textColumn3 && (
      <div>
        {titleColumn3 && (
          <h3
            className={styles.headline}
            {...inspectorProps?.({ fieldId: 'titleColumn3' })}
          >
            {titleColumn3}
          </h3>
        )}
        <RichText
          fields={textColumn3}
          inspectorProps={{ ...inspectorProps?.({ fieldId: 'textColumn3' }) }}
        />
      </div>
    )}
  </div>
);

export default ColumnBlock;
